import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Instagram, Twitter, Youtube, Phone, Mail, MapPin } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const sm = settings?.social_media || {};
  const siteName = settings?.site_name || 'KARGA AKADEMİ';
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 py-16 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-4 pl-1">
              <span className="text-2xl font-black" style={{ fontFamily: 'Outfit, sans-serif' }}>{siteName}</span>
            </div>
            <p className="text-[#71717A] text-sm leading-relaxed">{settings?.footer_text || "Karga ile hazır ol, fark yarat."}</p>
            <div className="flex items-center gap-4 mt-4">
              {sm.instagram && <a href={sm.instagram} target="_blank" rel="noopener noreferrer" className="text-[#71717A] hover:text-[#B026FF] transition-colors" data-testid="footer-instagram"><Instagram className="w-5 h-5" /></a>}
              {sm.twitter && <a href={sm.twitter} target="_blank" rel="noopener noreferrer" className="text-[#71717A] hover:text-[#B026FF] transition-colors" data-testid="footer-twitter"><Twitter className="w-5 h-5" /></a>}
              {sm.youtube && <a href={sm.youtube} target="_blank" rel="noopener noreferrer" className="text-[#71717A] hover:text-[#B026FF] transition-colors" data-testid="footer-youtube"><Youtube className="w-5 h-5" /></a>}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4 tracking-wide uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}>Sayfalar</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-[#71717A] hover:text-white transition-colors">Ana Sayfa</Link>
              <Link to="/about" className="block text-sm text-[#71717A] hover:text-white transition-colors">Hakkımızda</Link>
              <Link to="/packages" className="block text-sm text-[#71717A] hover:text-white transition-colors">Paketlerimiz</Link>
              <Link to="/blog" className="block text-sm text-[#71717A] hover:text-white transition-colors">Blog</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4 tracking-wide uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}>Hesap</h4>
            <div className="space-y-2">
              <Link to="/login" className="block text-sm text-[#71717A] hover:text-white transition-colors">Giriş Yap</Link>
              <Link to="/register" className="block text-sm text-[#71717A] hover:text-white transition-colors">Kaydol</Link>
              <Link to="/contact" className="block text-sm text-[#71717A] hover:text-white transition-colors">İletişim</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4 tracking-wide uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}>İletişim</h4>
            <div className="space-y-3">
              {settings?.contact_phone && (
                <div className="flex items-center gap-2 text-sm text-[#71717A]">
                  <Phone className="w-4 h-4 text-[#B026FF]" />
                  <a href={`tel:${settings.contact_phone}`} className="hover:text-white transition-colors">{settings.contact_phone}</a>
                </div>
              )}
              {settings?.contact_email && (
                <div className="flex items-center gap-2 text-sm text-[#71717A]">
                  <Mail className="w-4 h-4 text-[#B026FF]" />
                  <a href={`mailto:${settings.contact_email}`} className="hover:text-white transition-colors">{settings.contact_email}</a>
                </div>
              )}
              {settings?.contact_address && (
                <div className="flex items-center gap-2 text-sm text-[#71717A]">
                  <MapPin className="w-4 h-4 text-[#B026FF]" />
                  <span>{settings.contact_address}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-center">
          <p className="text-[#71717A] text-sm">&copy; 2026 Karga Akademi. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
